import useFeatureToggle from 'Client/hooks/useFeatureToggle';
import useGa from 'Client/hooks/useGa';
import { useBellaSelector } from 'Client/redux/hooks';
import { useSegmentTracking } from 'Common/segment';

const useAppTracking = () => {
    const gaTracking = useGa();
    const segmentTracking = useSegmentTracking();
    const { p100HotjarTracker, p100CtaColorChange } = useFeatureToggle();

    const journeyId = useBellaSelector(state => state.appShellLogin.journeyId);
    const trackAppWideVariations = (isWebView = false) => {
        gaTracking.trackVariation('p100HotjarTracker', p100HotjarTracker);
        if (!isWebView) {
            gaTracking.trackVariation('p100CtaColorChange', p100CtaColorChange);
        }
        segmentTracking.trackExperimentViewed({
            experiment_name: 'p100CtaColorChange',
            variation_name: `${!!p100CtaColorChange} ${journeyId}`,
        });
    };

    return {
        trackAppWideVariations,
    };
};

export default useAppTracking;
